import { useEffect } from "react";
import { useAuthContext } from "@asgardeo/auth-react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import About from "../pages/About/About";
import Account from "../pages/Account/Account";
import Benchmark from "../pages/Benchmark/Benchmark";
import Career from "../pages/Career/Career";
import CaseCitation from "../pages/CaseCitation/CaseCitation";
import CaseSummary from "../pages/CaseSummary/CaseSummary";
import TrilingualDictionary from "../pages/Dictionary/TrilingualDictionary";
import Help from "../pages/Help/Help";
import Home from "../pages/Home/Home";
import KnowledgeHub from "../pages/KnowledgeHub/KnowledgeHub";
import CenturyCatalysts from "../pages/LegalPages/CenturyCatalysts";
import Privacy from "../pages/LegalPages/Privacy";
import Refund from "../pages/LegalPages/Refund";
import Terms from "../pages/LegalPages/Terms";
import Legislations from "../pages/Legislations/Legislations";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import Reports from "../pages/Reports/Reports";
import Results from "../pages/Results/Results";
import Stats from "../pages/Stats/Stats";
import Translate from "../pages/Translate/Translate";
import Preapproval from "../pages/Preapproval/Preapproval";
import ChatPricing from "../pages/ChatPricing/ChatPricing";

const ProtectedSummaryRoute = ({ children }) => {
  const { state, signIn } = useAuthContext();

  useEffect(() => {
    if (state.isLoading || state.isAuthenticated) {
      return;
    }

    sessionStorage.removeItem("redirectToDocument");
    sessionStorage.removeItem("urlString");
    sessionStorage.setItem(
      "redirectAfterLogin",
      `${window.location.pathname}${window.location.search}`
    );
    signIn();
  }, [signIn, state.isAuthenticated, state.isLoading]);

  if (state.isLoading || !state.isAuthenticated) {
    return null;
  }

  return children;
};

const ProtectedProPlanRoute = ({ children }) => {
  const { state, signIn } = useAuthContext();

  const requireAuth = import.meta.env.VITE_PRO_PLAN_REQUIRE_AUTH === "true";

  useEffect(() => {
    if (!requireAuth) return;
    if (state.isLoading || state.isAuthenticated) return;

    sessionStorage.setItem(
      "redirectAfterLogin",
      `${window.location.pathname}${window.location.search}`
    );
    signIn();
  }, [requireAuth, signIn, state.isAuthenticated, state.isLoading]);

  if (requireAuth && (state.isLoading || !state.isAuthenticated)) {
    return null;
  }

  return children;
};


const LegacyCaseRouteRedirect = () => {
  const params = useParams();
  const legacySlug = params["*"] || "";

  return <Navigate to={`/judgments/${legacySlug}`} replace />;
};

const Router = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/authorize/:firmSlug" element={<Preapproval />} />
    <Route path="/help" element={<Help />} />
    <Route path="/benchmark" element={<Benchmark />} />
    <Route path="/stats" element={<Stats />} />
    <Route path="/about" element={<About />} />
    <Route path="/search" element={<Results />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/refund" element={<Refund />} />
    <Route path="/terms" element={<Terms />} />
    {/* <Route path="/century-pricing" element={<CenturyCatalysts />} /> */}
    {/* <Route path="/professional-plan" element={<ChatPricing />} /> */}
    <Route
      path="/professional-plan"
      element={
        <ProtectedProPlanRoute>
          <ChatPricing />
        </ProtectedProPlanRoute>
      }
    />
    <Route path="/careers" element={<Career />} />
    <Route path="/my-account" element={<Account />} />
    <Route path="/dictionary" element={<TrilingualDictionary />} />
    <Route path="/reports" element={<Reports />} />
    <Route path="/translate" element={<Translate />} />
    <Route path="/legislations" element={<Legislations />} />
    <Route path="/judgments/*" element={<CaseCitation />} />
    <Route path="/case/*" element={<LegacyCaseRouteRedirect />} />
    <Route
      path="/summary/*"
      element={
        <ProtectedSummaryRoute>
          <CaseSummary />
        </ProtectedSummaryRoute>
      }
    />
    <Route
      path="/standard_casenumber/*"
      element={
        <ProtectedSummaryRoute>
          <CaseSummary />
        </ProtectedSummaryRoute>
      }
    />
    {/* <Route path="/knowledge-hub" element={<KnowledgeHub />} /> */}
    {/* <Route path="/knowledge-hub/:slug" element={<KnowledgeHub />} /> */}
    <Route path="*" element={<PageNotFound />} />
  </Routes>
);

export default Router;
